<template>
  <div>
    <div
      class="text-muted price-yes"
    >
      <div class="vacancy-period">
        {{ $t('object:vacancy.price.for'+langKey, {count: langDuration }) }}
      </div>
      <div
        v-if="showStartAndEndDate"
        class="vacancy-dates"
      >
        <i
          v-if="changedTravelCoditions === 'Y'"
          v-b-tooltip
          class="icon clickable-element"
          :title="$t('object:vacancy.widget.differentPeriod')"
        >
          <icon-exclamation-triangle class="exclamation-triangle svg-icon svg-fill" />
        </i>
        <template
          v-if="endDateString !== ''"
        >
          {{ startDateString }} &dash; {{ endDateString }}
        </template>
        <template v-else>
          {{ $t('flatpickr:pickerInputAlternate.departure') }}: {{ startDateString }}
        </template>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @@author       ??
 * @@date         ??
 * @@description  displays a curation based on a startDate and endDate
 * @@usedby       Object --> ObjectVacancyForm --> ObjectVacancyPrice --> ObjectPrice
 */

import IconExclamationTriangle from 'ICON:IconExclamationTriangle';
/** Directive Tooltip */
import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'ObjectPriceDuration',
  components: {
    IconExclamationTriangle,
  },
  i18nOptions: { namespaces: ['object', 'flatpickr'] },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    // used to build the translation key
    duration: {
      type: Number,
      required: true,
    },
    // localized date string that gets displayed
    endDateString: {
      type: String,
      required: false,
      default: '',
    },
    // localized date string that gets displayed
    startDateString: {
      type: String,
      required: false,
      default: '',
    },
    showStartAndEndDate: {
      type: Boolean,
      default: false,
    },
    changedTravelCoditions: {
      type: String,
      default: '',
    },
  },
  computed: {
    langKey() { // used to build the translation key
      return this.duration % 7 === 0 ? 'Week' : 'Days';
    },
    // calculates the count of days or weeks needed to build the translation
    langDuration() {
      return this.duration % 7 === 0
        ? this.duration / 7
        : this.duration;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .exclamation-triangle {
  path {
      fill: var(--color_ci) !important;
  }
}
</style>
